import type { Creator } from '@/types/creator';

import httpClient from '../utils/httpClient';

interface SearchParams {
  uuids?: string[];
  searchPhrase?: string;
  maxResults?: number;
  offset?: number;
}

interface CreatorsResponse {
  data: Creator[];
}

export default {
  async index(searchPhrase?: string): Promise<CreatorsResponse> {
    const { data } = await httpClient.get('/api/creators', {
      params: {
        searchPhrase
      }
    });

    return data;
  },

  async search(params: SearchParams): Promise<CreatorsResponse> {
    const { data } = await httpClient.post('/api/creators/search', params);

    return data;
  }
};
